import React from "react";
import Select from "react-select";
import { Answer } from "../../apis";

type Props = {
  options: Array<Option>;
  selected?: Option;
  answerQuestion: (answer: Answer) => Promise<void>;
};

export const UnitizedChoiceSelect: React.FC<Props> = ({
  options,
  selected,
  answerQuestion,
}) => (
  <Select
    options={options}
    isMulti={false}
    isSearchable={false}
    value={selected}
    onChange={(e) => {
      const newSelect = e as Option;

      const answer = {
        questionType: "UNITIZED_CHOICE",
        value: newSelect.value,
      };

      answerQuestion({ answer });
    }}
    placeholder={""}
  />
);
